import { ReactNode } from "react";
import { Flex, Select, Text, InfoTooltip } from "src/elements";
import { OTouchedMark } from "./OTouched";

interface Props<T> {
  title: string;
  description?: string;
  options: Array<{ label: string; value: T; isDisabled?: boolean }>;
  value: T;
  setValue: (value: T) => void;
  isDisabled?: boolean;
  tooltip?: string | ReactNode;
  testId?: string;
  path?: string;
}

export const RuleSelect = <T,>({
  title,
  description,
  options,
  value,
  setValue,
  isDisabled,
  tooltip,
  testId,
  path,
}: Props<T>) => {
  return (
    <Flex column justify="center" padding="10px" gap="10px" data-testid={testId}>
      <Flex gap="5px" align="center" justify="center">
        <Text variant="small1" textAlign="center" isDisabled={isDisabled}>
          {title}
        </Text>
        {tooltip && <InfoTooltip tooltip={tooltip} />}
        <OTouchedMark path={path} />
      </Flex>

      {description && (
        <Text variant="small2" textAlign="center" isDisabled={isDisabled}>
          {description}
        </Text>
      )}

      <Flex width="fit-content" margin="0 auto">
        <Select
          width="max-content"
          options={options}
          value={value}
          setValue={setValue}
          isDisabled={isDisabled}
        />
      </Flex>
    </Flex>
  );
};
